import Pkcs11Config from './Pkcs11Config';

export default Pkcs11Config;
